<template>
  <article class="score-chart-container chart-wrapper">
    <div class="score-chart-wrap">
      <Loading v-show="loading" :msg="errorRef" :isError="!!errorRef" />
      <CanvasJSChart
        v-show="!loading"
        :options="chartOptions"
        ref="chart"
        @chart-ref="chartRef"
        :styles="{ width: '100%', height: '370px' }"
      />
    </div>
    <article class="radio-wrapper">
      <span class="radio-label highlight highlight__400">
        <img src="@/assets/images/pages/index/whiteflame.svg" alt="" />{{
          $t("chart1.interval")
        }}</span
      >
      <div class="radio-list">
        <UiRadioBtn @onChange="handleChange" :items="radioItems" />
      </div>
    </article>
  </article>
  <!-- <div style="position:relative;">
        <CanvasJSChart :options="chartOptions" ref="chart" @chart-ref="chartRef" :styles="{width: '100%', height: '360px'}"/>
        <div class="loader" style="position:absolute; top:0; width:100%; height:100%; background:black;" v-show="loading">
            <p>loading...</p>
        </div>
    </div> -->
  <!-- <div class="select-container">
        <div v-for="option in radioOptions" :key="option.id">
            <label :for="option.id">
                <input type="radio" :id="option.id" @change="radioChange(option.value)" v-model="selectedRadio" :value="option.value" name="radio-select"/><span>{{option.label}}</span>
            </label>
        </div>
    </div> -->
</template>

<script setup>
// import * as CanvasJS from '@canvasjs/charts';
import Loading from "@/components/common/Loading.vue";
import UiRadioBtn from "@/components/ui/RadioBtn.vue";
import { onMounted, ref, defineEmits, defineProps, watch, nextTick, watchEffect } from "vue";
import { getScoreChartData } from "@/api/chart/scoreApi";
import { getCssVariableValue } from "@/utils/utils";
const errorRef = ref("");
const emit = defineEmits(["mounted"]);
const props = defineProps({
  ticker: String,
});
const ticker = ref(props.ticker);

let ob_number = ref(50);
const isChartReady = ref(false);
const chartDataReady = ref(false);
const settingsApplied = ref(false);

// const radioItems = [
//     { key: 'day2', value: '2 Days', checked: true, ob_number:50 , name:'score-radio'},
//     { key: 'week1', value: '1 Weeks', checked: false, ob_number:200, name:'score-radio' },
//     { key: 'week3', value: '3 Weeks', checked: false, ob_number:600, name:'score-radio' },
// ]

const radioItems = ref(generateRadioList(props.ticker));

function generateRadioList(ticker) {
  return [
    {
      key: `${ticker}_day2`,
      value: "chart1.day2",
      checked: true,
      ob_number: 50,
      name: `${ticker}_scoreRadio`,
    },
    {
      key: `${ticker}_week1`,
      value: "chart1.week1",
      checked: false,
      ob_number: 200,
      name: `${ticker}_scoreRadio`,
    },
    {
      key: `${ticker}_week3`,
      value: "chart1.week3",
      checked: false,
      ob_number: 600,
      name: `${ticker}_scoreRadio`,
    },
  ];
}

watch(
  () => props.ticker,
  async (val) => {
    ticker.value = val;
    loading.value = true;

    radioItems.value = generateRadioList(val);

    await renderChart(ticker.value, ob_number.value);
  },
);

const handleChange = async (e) => {
  ob_number.value = e.selected.ob_number;
  // console.log("ob_number", ob_number);
  loading.value = true;
  await renderChart(ticker.value, ob_number.value);
};
const priceData = ref(null);
const scoreData = ref(null);

const loading = ref(true);

const chart = ref(null);
const chartOptions = ref({
  options: {
    responsive: true,
  },
  animationEnabled: true,
  theme: "dark2",
  padding: 30,
  creditText: "",
  backgroundColor: "transparent",
  title: {
    text:" ",
    margin:20,
    // text: "Vue.js Basic Column Chart"
  },
  legend: {
    verticalAlign: "top",
    horizontalAlign: "right",
    fontSize: 14,
    fontFamily: "Pretendard",
    fontWeight: "lighter",
    itemWidth: 100,
    markerMargin: 10,
    // itemclick: (e) => {
    //     console.log(e.dataSeries);
    //     if (typeof e.dataSeries.visible === "undefined" || e.dataSeries.visible) {
    //         e.dataSeries.visible = false;
    //     } else {
    //         e.dataSeries.visible = true;
    //     }
    //     e.chart.render();
    // }
  },
  toolTip: {
    shared: true, // 마우스 호버시 보이는 툴박스,
  },
  axisX: {
    //하단 시간축
    valueFormatString: "MM-DD HH:00", // Date(2016, 07, 15, 10, 30)  => 15 AUG
    // title: "Time",
    labelFontFamily: "Pretendard",
    interval: 1,
    intercalType: "hour",
    // viewportMinimum:priceArray[0].x,
    // viewportMaximum:priceArray[priceArray.length-1].x,
    margin: 20,
    labelWrap: true,
    labelAngle: 0,
    labelFontSize: 13,
    labelFontColor: getCssVariableValue("--chart-x-font-color"),
    fontFamily: "Pretendard",
  },
  axisX2: {
    margin: 40,
    title: "",
  },
  axisY: {
    //좌측 포인트축
    // title: "Score",
    // titleFontColor: "#5DB9CD",
    // gridColor: "#454951",
    suffix: " P",
    tickColor: "#FFF",
    labelFontFamily: "Pretendard",
    margin: 10,
    labelFontSize: 14,
    labelFontColor: getCssVariableValue("--chart-xy-font-color"),
    fontFamily: "Pretendard",
    gridColor:'transparent',
    // minimum:scoreMinValue,
    // maximum:scoreMaxValue
  },
  axisY2: {
    //우측 시세축
    // title: "MarketPrice",
    // titleFontColor: "#EE7272",
    suffix: " " + "USDT",
    tickColor: "transparent",
    labelFontSize: 14,
    labelFontColor: getCssVariableValue("--chart-xy-font-color"),
    labelFontFamily: "Pretendard",
    margin: 10, // 상하 x 좌우 마진만
    // labelFormatter:function(e){
    // return  "◀ " +  CanvasJS.formatNumber(e.value, "#,##0.####") ;
    // },
    // valueFormatString:"#,##0.#### " + "USDT"
    // minimum:priceMinValue,
    // maximum:priceMaxValue
  },
  data: [
    {
      type: "spline",
      name: " Score",
      showInLegend: true,
      xValueType: "dateTime",
      xValueFormatString: "DD MMM hh:mm TT", // => 일/월/ 시간/분 // 오전(오후)
      yValueFormatString: "#,##0.00 P",
      color: getCssVariableValue("--chart-candle-up"),
      includeInAxis: true,
      dataPoints: scoreData.value,
    },
    {
      type: "spline",
      axisYType: "secondary",
      name: " Price",
      showInLegend: true,
      includeInAxis: true,
      // yValueFormatString: "#,##0.#### " + "USDT",
      color: getCssVariableValue("--chart-candle-down"),
      dataPoints: priceData.value,
    },
  ],
});

// chartOptions 변경 후 차트가 렌더링되면 설정 적용
watchEffect(() => {
  if (chartDataReady.value && chart.value?.chart && chartOptions.value.data && !settingsApplied.value) {
    // chartOptions가 변경되고 차트가 준비되어 있으면 설정 적용
    const timer = setTimeout(() => {
      console.log('watchEffect: calling applyChartSettings');
      applyChartSettings();
      settingsApplied.value = true;
    }, 200);
    return () => clearTimeout(timer);
  }
});

onMounted(async () => {
  await renderChart(ticker.value, ob_number.value);
  emit("mounted");
});

const chartRef = (chartInstance) => {
  console.log('chartRef called', chartInstance);
  chart.value = chartInstance;
  isChartReady.value = true;
  console.log('chartDataReady.value', chartDataReady.value);
  console.log('chart.value?.chart', chart.value?.chart);
  
  // 차트가 준비되고 데이터도 준비되어 있으면 설정 적용
  if (chartDataReady.value && chart.value?.chart) {
    console.log('chartRef: calling applyChartSettings');
    // 차트가 자동으로 렌더링될 시간을 주기 위해 약간의 지연
    setTimeout(() => {
      applyChartSettings();
    }, 100);
  } else {
    console.log('chartRef: conditions not met', {
      chartDataReady: chartDataReady.value,
      hasChart: !!chart.value?.chart
    });
  }
};

const renderChart = async (symbol, count) => {
  // console.log('await getScoreChartData(selectedSymbol.value,50)',await getScoreChartData(selectedSymbol.value,50));
  // console.log("chart.value", chart.value);
  settingsApplied.value = false;
  
  let result = await getScoreChartData(symbol, count);
  // console.log("data", result);
  if (result.status == "fail") {
    errorRef.value = "Unsupported Coin.";
  } else {
    priceData.value = result.priceArray;
    scoreData.value = result.scoreArray;
    // console.log(priceData.value,scoreData.value);

    let lastTime = priceData.value[priceData.value.length - 1].x;
    let paddingHour;
    if(count <= 50 ) {
      paddingHour = 1;
    }else if(count <= 200){
      paddingHour = 2;
    }else if(count <= 600){
        window.innerWidth >=576 ? paddingHour = 10 : paddingHour = 20;
    }
    let lastTimePadding = lastTime + 1000*60*60 * paddingHour;

    chartOptions.value = {
      ...chartOptions.value,
      axisX: {
        //하단 시간축
        valueFormatString: "MM-DD HH:00", // Date(2016, 07, 15, 10, 30)  => 15 AUG
        // title: "Time",
        labelFontFamily: "Pretendard",
        interval: 1,
        intercalType: "hour",
        // viewportMinimum:priceArray[0].x,
        // viewportMaximum:priceArray[priceArray.length-1].x,
        margin: 20,
        labelWrap: true,
        labelAngle: 0,
        labelFontSize: 13,
        labelFontColor: getCssVariableValue("--chart-x-font-color"),
        fontFamily: "Pretendard",
        viewportMaximum:lastTimePadding,
      },
      data: [
        {
          ...chartOptions.value.data[0],
          dataPoints: scoreData.value,
        },
        {
          ...chartOptions.value.data[1],
          dataPoints: priceData.value,
        },
        {
          ...chartOptions.value.data[2],
        },
      ],
    };
    chartDataReady.value = true;
    // 차트 렌더링
    if (chart.value?.chart) {
      console.log('renderChart: calling applyChartSettings');
      // chartOptions 변경 후 차트가 자동으로 렌더링될 시간을 주기 위해 약간의 지연
      setTimeout(() => {
        applyChartSettings();
      }, 100);
    } else {
      console.log('renderChart: chart not ready yet, will be called from chartRef');
    }
    loading.value = false;
  }
};

const applyChartSettings = () => {
  console.log('applyChartSettings called');
  console.log('chart.value', chart.value);
  console.log('chart.value?.chart', chart.value?.chart);
  
  if (!chart.value?.chart) {
    console.log('applyChartSettings: chart not ready');
    return;
  }
  
  try {
    chart.value.chart.render();
    console.log('render chart');
    
    console.log('chart.value.axisY[0].maximum', chart.value.chart.axisY[0].maximum);
    let axisYMax = chart.value.chart.axisY[0].maximum;
    let axisYMin = chart.value.chart.axisY[0].minimum;
    let axisYInterval = chart.value.chart.axisY[0].interval;
    let axisY2Interval = chart.value.chart.axisY2[0].interval;
    let axisY2Min = chart.value.chart.axisY2[0].minimum;
    let axisY2Max = chart.value.chart.axisY2[0].maximum;
    // 그리드 라인 개수 계산: (최댓값 - 최솟값) / interval + 1
    const gridLineCount = (axisYMax - axisYMin) / axisYInterval + 1;
    const gridLineCount2 = (axisY2Max - axisY2Min) / axisY2Interval + 1;

    const totalGridLineCount = gridLineCount2 > gridLineCount ? Math.max(gridLineCount, gridLineCount2) : gridLineCount2;
    
    let centerAxisYValue = (axisYMax + axisYMin) / 2;
    
    // stripLines 배열 생성: 각 그리드 라인 위치에 stripLine 추가
    const stripLines = [];
    for(let i = 0; i < totalGridLineCount; i++) {
        const value = axisY2Min + axisY2Interval * (i+1);
        stripLines.push({
            value: value,
            showOnTop: true,
            color: "#454951",
            thickness: 1,
            lineDashType: "solid"
        });
    }
    let centerAxisYValueStripLines = [];
    if(gridLineCount - gridLineCount2 >= 1) {
        centerAxisYValueStripLines.push({
            value: centerAxisYValue,
            showOnTop: true,
            color: "#454951",
            thickness: 1,
            lineDashType: "solid"
        });
    }
    
    console.log('stripLines', stripLines);
    
    if(stripLines.length > 0) {
        chart.value.chart.axisY2[0].set('stripLines', stripLines);
        if(centerAxisYValueStripLines.length > 0) {
            // this._scoreChart.axisY[0].set('stripLines', centerAxisYValueStripLines);
        }
    }
  } catch (error) {
    console.error('applyChartSettings error:', error);
  }
};

</script>

<style lang="scss" scoped>
@import "@/assets/scss/components/charts/score.scss";
</style>
